import { INVITE_USER_DATA_REQUEST, INVITE_USER_DATA_REQUEST_SUCCESS, INVITE_USER_DATA_REQUEST_FAILURE } from '../constants/invite_user_data.constants';

export const inviteUserDataRequest = () => ({
    type: INVITE_USER_DATA_REQUEST,
});

export const inviteUserDataRequestSuccess = payload => ({
    type: INVITE_USER_DATA_REQUEST_SUCCESS, payload,
});

export const inviteUserDataRequestFailure = error => ({
    type: INVITE_USER_DATA_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/actions/invite_user_data.actions.js